import {useEffect, useState} from "react";
import {OfferCard, OfferCardTech} from "../../components/offer/Card";
import {useFetchOffers} from "../../../hooks/useOffers";
import Loader from "../../components/shared/Loader";
import {useInView} from "react-intersection-observer";
import {
  interventionStatus,
  offerStatus,
  userRoleList,
} from "../../../utils/constants";
import {useMe} from "../../../hooks/useGetUser";
import imagePub from "../../../images/ImagePub.jpg";
import imageAvancement from "../../../images/AvancementProfile.png";
import arrow from "../../../images/arrowIntervention.png";
import BgPattern from "../../../images/BG-Pattern.png";
import Weather from "../../components/shared/Weather";
import FilterCard from "../../components/offer/filterCard";
import StarIcon from "../../../images/icons/starIcon";
import ImageComponent from "../../components/shared/ImageComponent";
import {buildImageUrl} from "../../../utils/imageUrlBuilder";
import NoImage from "../../../images/NoImage.jpg";
import NoProfile from "../../../images/profileImage.png";
import Crown from "../../../images/crownIcon.svg";
import useUserSectors from "../../../hooks/useUsersSectors";
import ListCardOffer from "../../components/offer/ListCard";
import InterventionItem from "../../components/offer/interventionItem";
import {useDailyIntervention} from "../../../hooks/useInterventions";
import {interventionStatusOptions} from "../../../utils/status";
import {simpleDate} from "../../../utils/date";
import {Link} from "react-router-dom";
import ProfileCompletion from "../../components/Profile/ProfileCompletion";
import PubList from "../../components/shared/PubList";

const ListMesOfferPage = (Props) => {
  const [searchValue, setsearchValue] = useState("");
  const {data, isLoading: isMeLoading} = useMe();
  const {subCategories} = useUserSectors();

  const today = new Date();
  const {interventions, isError, isLoading} = useDailyIntervention({
    size: 5,
    filter: {
      startDate: simpleDate(today),
      status: [
        interventionStatus.NEW,
        interventionStatus.PROCESSING,
        interventionStatus.REPORTED,
      ],
    },
    order: [["startDate", "ASC"]],
  });
  const [filterBut, setFilterBut] = useState(false);
  const [filter, SetFilter] = useState({
    size: 8,
    order: [["id", "DESC"]],
    filter:
      data?.selectedRole === userRoleList.TECHNICIAN
        ? {
            statuses: [offerStatus.PUBLIC, offerStatus.PROCESSING],
            subCategoryIds: !!subCategories?.length
              ? subCategories?.map((el) => el.id)
              : [],
          }
        : {clientId: data?.Client?.id, sectorIds: []},
    search: "",
  });
  const [filterTouched, setFilterTouched] = useState(false);

  useEffect(() => {
    if (!isMeLoading && data) {
      const newFilter =
        data.selectedRole === userRoleList.TECHNICIAN
          ? {
              statuses: [offerStatus.PUBLIC],
              subCategoryIds: subCategories?.length
                ? subCategories.map((el) => el.id)
                : [],
            }
          : {clientId: data?.Client?.id, sectorIds: []};

      SetFilter((prevFilter) => ({
        ...prevFilter,
        filter: newFilter,
        search: "",
      }));
    }
  }, [data, subCategories, isMeLoading]);

  useEffect(() => {}, [filterTouched]);

  if (isMeLoading) {
    return <Loader />;
  }

  return (
    <>
      <div className="w-full  lg:grid lg:grid-cols-4 gap-6 ">
        <div className="w-full h-fit bg-white rounded-2xl hidden lg:block sticky top-[90px]  ">
          <div
            className="w-full h-[84px] bg-cover bg-center rounded-t-xl relative "
            style={{backgroundImage: `url('${BgPattern}')`}}
          >
            <div className="absolute -bottom-12 rounded-md left-[50%] -translate-x-[50%]">
              <div className="relative">
                {!!data?.avgRating && (
                  <Link
                    to={"/mon-profil/#avis"}
                    className="bg-[#FFC107] w-1/2 flex justify-center gap-[2px] items-center leading-none p-[1px] text-white text-[12px] absolute bottom-0 rounded-md left-[50%] -translate-x-[50%] "
                  >
                    {Number(data?.avgRating).toFixed(2)}
                    <StarIcon className="fill-white stroke-none w-3 h-3" />
                  </Link>
                )}
                {/* <div className="absolute w-6 h-6 bg-white flex justify-center items-center top-1 right-1 text-[#1A64B9] rounded-full">
                  <img className="w-4" src={Crown} alt="" title="Professionnel" />{" "}
                </div> */}
                <ImageComponent
                  src={buildImageUrl(data?.imageUri)}
                  alt=""
                  className=" w-[104px] h-[104px] rounded-full object-cover ring-4 ring-white"
                  fallback={
                    <img
                      src={NoProfile}
                      alt=""
                      className=" w-[104px] h-[104px] rounded-full object-cover ring-4 ring-white"
                      width="130"
                    />
                  }
                />
              </div>
            </div>
          </div>
          <div className="flex flex-col justify-start items-center mt-14">
            <Link
              to={"/mon-profil"}
              className="text-center text-[#19295C] font-semibold capitalize "
            >
              {`${data.lastName}  ${data.firstName}`}
            </Link>
            <div className="text-center text-primary font-normal text-sm">
              {data.selectedRole === userRoleList.TECHNICIAN
                ? "Prestataire"
                : "Client"}
            </div>
            <Link
              to={"/mon-profil#avis"}
              className="text-right lg:text-center flex-grow  lg:flex-grow-0 text-xs font-normal lg:mt-3  underline text-[#7E7E7E] "
            >
              {data?.reviews?.length ?? 0} évaluation(s)
            </Link>
            <Link
              to="/deposer-une-annonce"
              className="w-full flex justify-start gap-[12px] items-center cursor-pointer text-xl text-[#6B6B6B] border-t border-b border-solid border-[#D6E2EF] px-4 py-3 group hover:text-[#FF6600] mt-3 "
            >
              <i className="fi fi-rr-multiple flex items-center"></i>
              <span className="font-semibold text-[14px] text-[#9B9B9B] group-hover:text-[#FF6600] ">
                Créer une annonce
              </span>
            </Link>
            <Link
              to={"/mon-profil"}
              className="w-full flex justify-start gap-[12px] items-center cursor-pointer text-xl text-[#6B6B6B] group hover:text-[#FF6600] px-4 py-3 "
            >
              <i className="fi fi-rr-user flex justify-center items-center group-hover:text-[#FF6600]"></i>
              <span className="font-semibold text-[14px] text-[#9B9B9B] group-hover:text-[#FF6600]  ">
                Mon profil
              </span>
            </Link>
          </div>
        </div>
        <div className="w-full col-span-2 flex flex-col  px-4 lg:!px-0 justify-start items-center gap-3">
          {/* <div className="w-full flex justify-between">
            <div className="flex w-5/6 max-w-[350px] text-[#7E7E7E] items-center gap-2 bg-white rounded-[28px] p-3 ">
              <i className="fi fi-rr-search flex justify-center items-center"></i>
              <input
                className="border-none flex-grow placeholder:text-[#7E7E7E] "
                type="text"
                placeholder="Rechercher une annonce..."
                value={searchValue}
                onChange={(e) => setsearchValue(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    SetFilter((prevFilter) => ({
                      ...prevFilter,
                      search: searchValue,
                    }));
                     // For debugging
                  }
                }}
              />
              {!!searchValue && (
                <i
                  class="fi fi-rr-cross-small flex items-center cursor-pointer"
                  onClick={() => {
                    setsearchValue("");
                    SetFilter((prevFilter) => ({
                      ...prevFilter,
                      search: "",
                    }));
                  }}
                ></i>
              )}
            </div>

            <div
              className="flex justify-center items-center bg-white w-14 h-14 rounded-full text-[#19295C] cursor-pointer"
              onClick={() => {
                setFilterBut((prev) => !prev);
              }}
            >
              <i className="fi fi-rr-filter flex justify-center items-center relative">
                {!!filterTouched && (
                  <div className="w-[10px] h-[10px] absolute -top-[7px] -right-[7px] bg-[#FF6600] rounded-full"></div>
                )}
              </i>
            </div>
          </div> */}
          <div className="text-[#19295C] font-bold text-base w-full text-left sm:text-lg 2xl:text-xl">
            Mes annonces
          </div>
          <div className="w-full flex flex-col gap-4">
            <ListCardOffer filter={filter} />
          </div>
        </div>

        <div className="w-full hidden  h-fit    pb-4  lg:flex flex-col gap-4 self-start  ">
          <Weather />
          <div className="w-full rounded-2xl  bg-white flex flex-col text-[#19295C] font-bold text-xl ">
            <div className="w-full flex items-start justify-between !py-3 !pl-3 !pr-1">
              <span className="font-semibold text-lg">
                Interventions à venir
              </span>
              <Link to={"/interventions"}>
                <img src={arrow} className="cursor-pointer" alt="" />
              </Link>
            </div>
            {isLoading && <Loader />}
            {isError && (
              <div className="p-4 text-red text-center">
                "Oups ! Un problème est survenu lors de la récupération des
                données. Veuillez vérifier votre connexion ou réessayer plus
                tard."
              </div>
            )}
            {interventions && !!interventions.length ? (
              interventions.map((intervention) => (
                <InterventionItem
                  key={intervention.id}
                  intervention={intervention}
                  className={"border-b border-solid border-[#D6E2EF] "}
                />
              ))
            ) : (
              <div className="text-center py-3 font-medium text-base text-[#7e7e7e]">
                Pas d'interventions.
              </div>
            )}
          </div>

          <PubList />
        </div>
      </div>
    </>
  );
};

export default ListMesOfferPage;
